/* eslint-disable @typescript-eslint/no-explicit-any */
export type TriState = "all" | "true" | "false";
export type LeadCountPreset = "all" | "noLeads" | "hasLeads" | "custom";

export type CustomFieldFilterMap = Record<string, string>;

export function compactAppliedFilters(
  fields: Record<string, any>,
  defaults: Record<string, any>,
  cfFilters?: CustomFieldFilterMap
) {
  const applied: Record<string, any> = {};
  for (const [key, defaultVal] of Object.entries(defaults)) {
    const value = fields[key];
    if (value == null || value === "" || value === defaultVal) continue;
    applied[key] = value;
  }
  for (const [id, value] of Object.entries(cfFilters ?? {})) {
    if (!value || value === "all") continue;
    applied[`cf_${id}`] = value;
  }
  return applied;
}
